/**
 * Edit API key: pure validation.
 *
 * `validateDraft` mirrors the rules the original `EditApiKey` page enforced
 * inline (`name.trim() && scopes.length > 0 && status`): name required, at least
 * one scope, a status chosen. Pure (no React/Redux/fetch) so it is unit-tested
 * directly and reused by the slice's selector and the saga.
 */
import type { ApiKeyDraft, ValidationErrors } from './api-key-draft.model';

export function validateDraft(draft: ApiKeyDraft): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!draft.name.trim()) errors.name = 'Name is required.';
  if (draft.scopes.length === 0) errors.scopes = 'At least one scope is required.';
  if (!draft.status) errors.status = 'Status is required.';

  return errors;
}
